import { createStyles, Typography, withStyles, WithStyles } from '@material-ui/core';
import React from 'react';

import { colors } from '../../themes/colors';
import PageContainer from '../PageContainer';

const styles = () =>
  createStyles({
    layoutContainer: {
      backGroundColor: colors.gray17,
    },
    errorImage: {
      objectFit: 'contain',
      width: 270,
      height: 282,
      margin: '30px 30px 0 30px',
    },
    errorContainer: {
      margin: '30px auto 0',
      textAlign: 'center',
    },
    titleText: {
      color: colors.black2,
      fontSize: '24px',
      fontWeight: 900,
      textAlign: 'center',
      maxWidth: '350px',
    },
    subTitleText: {
      color: colors.gray11,
      fontSize: '14px',
      fontWeight: 500,
      textAlign: 'center',
      margin: '10px auto 16px',
    },
  });

type Props = WithStyles<typeof styles> & {
  mainMessage?: string;
  subMessage?: string;
};

const DefaultError: React.FC<Props> = ({ classes, mainMessage, subMessage, children }) => {
  if (!mainMessage) {
    mainMessage = 'Something went wrong';
  }
  return (
    <PageContainer showSidebar={false}>
      <div className={classes.errorContainer}>
        <img
          className={classes.errorImage}
          src={require('../../assets/images/error-image.jpg')}
          alt="error-page"
        />
        <Typography className={classes.titleText}>{mainMessage}</Typography>
        {subMessage && <Typography className={classes.subTitleText}>{subMessage}</Typography>}
        {children}
      </div>
    </PageContainer>
  );
};

export default withStyles(styles)(DefaultError);
